import React from 'react';
import { FileText, Ghost, Share2, Calendar, TrendingUp } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    icon: <FileText className="w-8 h-8 text-gaming-purple-light" data-id="element-216" />,
    title: 'Guía de Jugador a Streamer (PDF)',
    desc: 'El mapa paso a paso para configurar tu canal para el crecimiento desde el día 1.'
  }, {
    icon: <Ghost className="w-8 h-8 text-gaming-purple-light" data-id="element-217" />,
    title: 'Protocolo Ghost-Proof',
    desc: 'Técnicas de narración constante para que nunca haya un silencio incómodo en tu stream.'
  }, {
    icon: <Share2 className="w-8 h-8 text-gaming-purple-light" data-id="element-218" />,
    title: 'La Matriz de Networking de Guerrilla',
    desc: 'Cómo robar tráfico de TikTok e Instagram de forma ética y llevarlos a tu directo.'
  }, {
    icon: <Calendar className="w-8 h-8 text-gaming-purple-light" data-id="element-219" />,
    title: 'Calendario de Juegos de Baja Competencia',
    desc: 'La lista secreta de nichos donde los nuevos espectadores realmente buscan canales.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-gaming-purple-light" data-id="element-220" />,
    title: 'Hoja de Ruta de 30 Días al Afiliado',
    desc: 'El plan diario exacto para monetizar tu contenido lo antes posible.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gaming-bg relative" data-id="element-221">
      <div className="max-w-6xl mx-auto" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <h2 className="font-orbitron text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-224">
            Lo que obtienes{' '}
            <span className="text-gaming-purple-light" data-id="element-225">hoy</span>
          </h2>
          <div className="w-24 h-1 bg-gaming-purple mx-auto rounded-full box-glow-purple" data-id="element-226" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-227">
          {deliverables.map((item, index) => <div key={index} className={`bg-gaming-card border border-gaming-purple/20 p-8 rounded-xl hover:border-gaming-purple/60 transition-all duration-300 hover:-translate-y-2 box-glow-purple group ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-228">
              <div className="bg-gaming-bg w-16 h-16 rounded-lg flex items-center justify-center mb-6 border border-gaming-purple/30 group-hover:scale-110 transition-transform" data-id="element-229">
                {item.icon}
              </div>
              <h3 className="text-white font-orbitron font-bold text-xl mb-3" data-id="element-230">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-231">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}